exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".navigation__externalLink__3B4mB .navigation__externalIcon__3QWSf{width:0;height:18px;opacity:0;transition-duration:.15s;transition-property:opacity,width,margin}.navigation__externalLink__3B4mB:hover .navigation__externalIcon__3QWSf{opacity:.75;width:18px;margin-right:6px}", ""]);

// exports
exports.locals = {
	"externalLink": "navigation__externalLink__3B4mB",
	"externalIcon": "navigation__externalIcon__3QWSf"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"modules":true,"importLoaders":2,"localIdentName":"[name]__[local]__[hash:base64:5]","sourceMap":false}!./node_modules/postcss-loader/lib?{"config":{"path":"/buildeng/bamboo-agent-home/xml-data/build-dir/TRE-WEB-BWP/.build/prod/build-2445/tools/webpack/postcss.config.js"},"sourceMap":true}!./node_modules/less-loader/dist/cjs.js?{"outputStyle":"expanded","sourceMap":false}!./app/scripts/views/home/presentational/navigation.less
// module id = Uvzk
// module chunks = 12